import * as React from "react";
import { Mutation } from "react-apollo";
import { Form, Label, FormGroup, Button } from "reactstrap";
import * as moment from "moment";

// GraphQL
import AcceptCustomerRequest from "../../GraphQL/Mutations/AcceptCustomerRequest";
import GetCompanyRequests from "../../GraphQL/Queries/GetCompanyRequests";

// Presentation/UI
import Loader from "../../Components/Loader";

interface IProps {
  companyId: any;
  request: any;
  closeModal(): void;
  notification(message: string): void;
}

interface IState {
  id: string;
  createdAt: string;
  timeOfRequest: string;
  title: string;
  description: string;
  priority: string;
  status: string;
  customerName: string;
  customerEmail: string;
  loading: boolean;
  error: null | string;
}

class EditRequestForm extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      id: props.request.id,
      createdAt: moment(props.request.createdAt).format("DD/MM/YYYY"),
      timeOfRequest: moment(props.request.createdAt).format("HH:mm"),
      title: props.request.title,
      description: props.request.description,
      priority: props.request.priority,
      status: props.request.status,
      customerName: props.request.customer.name,
      customerEmail: props.request.customer.email,
      loading: false,
      error: null
    };
  }
  render() {
    const {
      id,
      createdAt,
      timeOfRequest,
      priority,
      status,
      title,
      description,
      customerName,
      customerEmail
    } = this.state;
    const { companyId, closeModal, notification } = this.props;

    return (
      <Mutation<{}, {}> mutation={AcceptCustomerRequest}>
        {(acceptRequest, { loading, error }) => (
          <Form
            onSubmit={e => {
              e.preventDefault();
              this.setState({ loading: true });

              acceptRequest({
                variables: {
                  id,
                  companyId,
                  title,
                  description
                },
                refetchQueries: [
                  {
                    query: GetCompanyRequests,
                    variables: { id: companyId }
                  }
                ]
              })
                .then(res => {
                  this.setState({ loading: false });

                  closeModal();
                  notification("Request has been accepted");
                })
                .catch(err => {
                  this.setState({ loading: false });
                });
            }}
          >
            <FormGroup>
              <Label>Customer</Label>
              <br />
              {customerName}
              <br />
            </FormGroup>
            <FormGroup>
              <Label>Customer Email</Label>
              <br />
              {customerEmail}
              <br />
            </FormGroup>
            <FormGroup>
              <Label>Title</Label>
              <br />
              {title}
              <br />
            </FormGroup>
            <FormGroup>
              <Label>Description</Label>
              <br />
              {description}
              <br />
            </FormGroup>
            <FormGroup>
              <Label>Date Of Request</Label>
              <br />
              {createdAt}
              <br />
            </FormGroup>
            <FormGroup>
              <Label>Time Of Request</Label>
              <br />
              {timeOfRequest}
              <br />
            </FormGroup>
            <FormGroup>
              <Label>Priority</Label>
              <br />
              {priority}
              <br />
            </FormGroup>
            <br />
            {status === "REJECT" || status === "ACCEPT" ? (
              "You have responded to this request."
            ) : (
              <FormGroup>
                <Button>
                  {!this.state.loading ? (
                    <span>Accept Request</span>
                  ) : (
                    <Loader />
                  )}
                </Button>
              </FormGroup>
            )}
          </Form>
        )}
      </Mutation>
    );
  }
}

export default EditRequestForm;



// WEBPACK FOOTER //
// ./src/Containers/Requests/EditRequestForm.tsx